import { BusinessTerm } from '@wix/ambassador-funnel-taxonomy-v1-business-term/types'
import { Text } from '@wix/design-system'
import React, { FC } from 'react'

import s from './WixMobileCategoriesSearchResults.scss'

interface WixMobileCategorySearchDropdownProps {
  categories: BusinessTerm[]
  onCategoryClick: (category: BusinessTerm, index: number) => void
}

export const WixMobileCategoriesSearchResults: FC<WixMobileCategorySearchDropdownProps> = ({
  categories,
  onCategoryClick,
}) => {
  return (
    <ol className={s.list}>
      {categories.map((category, index) => (
        <li
          key={category.displayName}
          className={s.item}
          onClick={() => {
            onCategoryClick(category, index)
          }}
        >
          <Text className={s.label}>
            {category.displayNameMatches?.map(match => (match.isMatched ? <b>{match.text}</b> : match.text)) ??
              category.displayName}
          </Text>
        </li>
      ))}
    </ol>
  )
}
